module.exports = __webpack_public_path__ + "media/2.1c5c24aa.mp3";